import { TransitOperation } from '../models/types'
import { fromTransitOperationResponse, toUpdateRequest } from '../models/mapper'
import { TransitOperationSave } from '../models/request'
import { createTransitOperationV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createTransitOperation(transitOperation: TransitOperationSave): Promise<TransitOperation> {
  const response = await createTransitOperationV2(toUpdateRequest(transitOperation))

  return fromTransitOperationResponse(response)
}

